import React, { FC, useEffect } from 'react';
import { LoadingBlock } from '../LoadingBlock';
import { handleAuthentication, fetchUserPermissions } from '../../actions/AccountActions';
import { useHistory } from 'react-router-dom';
import { ApplicationRoutes } from '../../routes/ApplicationRoutes';
import { useReduxDispatch } from '../../hooks/redux/useReduxDispatch';

const Callback: FC = () => {
    const dispatch = useReduxDispatch();
    const history = useHistory();

    // Run this effect once immediately when the component hits the dom.
    // This component will always redirect the user to another page essentially immediately.
    useEffect(() => {
        async function handleCallback() {
            const results = await dispatch(handleAuthentication());
            if(results) {
                await dispatch(fetchUserPermissions());
                history.push(ApplicationRoutes.applicationRoot);
            }
        }
        handleCallback();
    }, []);

    return (
        <div style={{width: '100%', height: '100%', backgroundColor: 'white', padding: '50px'}}>
            <LoadingBlock />
        </div>
    );
};

export default Callback;